import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import utils from '../../utils/utils';
import DATE_FORMAT from '../../components/constants/dateFormat';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS from '../../components/constants/deliveryDayMarketplaceInventoryStatus';
import ITEM_CUSTOM_PACKING_TYPE from '../../components/constants/itemCustomPackingType';
import classNames from 'classnames';

function isReceived(ddm) {
  return (
    [
      DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.complete,
      DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.completeWithErrors,
    ].indexOf(ddm.inventoryStatus) !== -1
  );
}

const PackerDeliveryDayRow = ({ deliveryDay, showMarketplaces }) => {
  const [showDeliveryDayMarketplaces, setShowDeliveryDayMarketplaces] = useState(showMarketplaces);

  const deliveryDate = utils.getDateFromString(deliveryDay.deliveryDate).format(DATE_FORMAT.displayWithTimeAndWeekday);

  const marketplacesWithOrdersAndReceived = deliveryDay.marketplaces
    .filter((marketplace) => marketplace.totalSum > 0 && isReceived(marketplace))
    .sort((a, b) => a.marketplaceName.localeCompare(b.marketplaceName));

  const marketplacesWithOrdersAndNotReceived = deliveryDay.marketplaces
    .filter((marketplace) => marketplace.totalSum > 0 && !isReceived(marketplace))
    .sort((a, b) => a.marketplaceName.localeCompare(b.marketplaceName));
  const groupedMarketplacesWithOrdersNotReceived = utils.groupBy(
    marketplacesWithOrdersAndNotReceived,
    'marketplaceTransportType'
  );

  const marketplacesWithoutOrders = deliveryDay.marketplaces.filter((marketplace) => marketplace.totalSum === 0);

  const routesLink = `/admin/packing/deliveryDays/${deliveryDay.id}`;

  return (
    <div className="packer__delivery-days-day m-b-3">
      <Link to={routesLink}>
        <h3 className="m-b-3">
          #{deliveryDay.id} - {deliveryDate}
        </h3>
      </Link>
      <div className="m-b-1">
        {Object.keys(ITEM_CUSTOM_PACKING_TYPE).map((key) => {
          const type = ITEM_CUSTOM_PACKING_TYPE[key];

          const badgeClasses = classNames({
            'badge m-r-1 p-a-1': true,
            'badge-secondary': true,
          });

          return (
            <Link to={`/admin/packing/deliveryDays/${deliveryDay.id}/${type.name}`} key={key} className={badgeClasses}>
              {type.icon} <FormattedMessage id={`item.form.field.custom.packing.type.name.${type.name}`} />
            </Link>
          );
        })}
      </div>
      <div>
        <div className="m-b-1">
          <button
            className="btn btn-small btn-normal-link"
            onClick={() => setShowDeliveryDayMarketplaces(!showDeliveryDayMarketplaces)}
          >
            <small>
              <FontAwesomeIcon icon={showDeliveryDayMarketplaces ? faCaretUp : faCaretDown} />{' '}
              <FormattedMessage id={'packer.delivery.days.delivery.day.show.marketplaces'} />
            </small>
          </button>
        </div>
        {showDeliveryDayMarketplaces ? (
          <>
            {Object.keys(groupedMarketplacesWithOrdersNotReceived).map((key) => {
              const ddms = groupedMarketplacesWithOrdersNotReceived[key];
              ddms.sort((a, b) => a.marketplaceName.localeCompare(b.marketplaceName));

              return (
                <div key={key} className="m-b-2">
                  <h5 className="m-b-1">
                    {key !== 'null' ? (
                      <FormattedMessage id={`marketplace.form.field.transport.type.name.${key}`} />
                    ) : (
                      '-'
                    )}
                  </h5>
                  {ddms.map((ddm, index) => {
                    const receivedLink =
                      [DELIVERY_DAY_MARKETPLACE_INVENTORY_STATUS.inProgress].indexOf(ddm.inventoryStatus) !== -1 ? (
                        <small className="text-muted">
                          💃{' '}
                          <FormattedMessage
                            id={'packer.delivery.days.delivery.day.marketplace.inventory.in.progress'}
                          />
                        </small>
                      ) : (
                        ''
                      );

                    return (
                      <div key={index} className="text-large">
                        <Link to={`/admin/packing/deliveryDayMarketplaces/${ddm.id}`}>{ddm.marketplaceName}</Link>{' '}
                        {receivedLink}
                      </div>
                    );
                  })}
                </div>
              );
            })}
            {marketplacesWithOrdersAndReceived.map((ddm, index) => {
              const receivedLink = isReceived(ddm) ? (
                <small className="text-muted">✅</small>
              ) : (
                <span className="text-muted">☑</span>
              );

              return (
                <div key={index}>
                  <Link to={`/admin/packing/deliveryDayMarketplaces/${ddm.id}`}>{ddm.marketplaceName}</Link>{' '}
                  {receivedLink}
                </div>
              );
            })}
            <div className="m-b-1" />
            {marketplacesWithoutOrders.map((marketplace, index) => (
              <div key={index} className="text-muted">
                {marketplace.marketplaceName}
              </div>
            ))}
          </>
        ) : (
          ''
        )}

        <div className="m-t-3 m-b-2">
          <Link to={routesLink} className="btn btn-primary">
            <FormattedMessage id={'packer.delivery.days.delivery.day.cta'} />
          </Link>
        </div>
      </div>
    </div>
  );
};

PackerDeliveryDayRow.propTypes = {
  deliveryDay: PropTypes.object.isRequired,
  showMarketplaces: PropTypes.bool.isRequired,
};

PackerDeliveryDayRow.defaultProps = {};

export default PackerDeliveryDayRow;
